/**
 * Switch between light and dark themes (color modes)
 * Copyright 2024 AppsFlow
 */

;(() => {
  'use strict'

  // const getStoredTheme = () => localStorage.getItem('theme')
  const getStoredTheme = () => {
    const name = 'theme='
    const decodedCookie = decodeURIComponent(document.cookie)
    const cookieArray = decodedCookie.split(';')

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim()
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }
    return null
  }
  // const setStoredTheme = theme => localStorage.setItem('theme', theme)
  const setStoredTheme = (theme) => {
    // Get domain for cookie sharing across subdomains
    const domain = window.location.hostname.split('.').slice(-2).join('.')
    // Set cookie with 30 days expiration and domain attribute for subdomain sharing
    const expirationDate = new Date()
    expirationDate.setDate(expirationDate.getDate() + 180)
    document.cookie = `theme=${theme};expires=${expirationDate.toUTCString()};path=/;domain=.${domain}`
  }

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
      return storedTheme
    }

    // Set default theme to 'light'.
    // Possible options: 'dark' or system color mode (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    // return 'light'
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
  }

  const setTheme = (theme) => {
    if (
      theme === 'auto' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  setTheme(getPreferredTheme())

  const showActiveTheme = (theme) => {
    const themeSwitcher = document.querySelector('[data-bs-toggle="mode"]')

    if (!themeSwitcher) {
      return
    }

    const themeSwitcherCheck = themeSwitcher.querySelector(
      'input[type="checkbox"]'
    )

    if (theme === 'dark') {
      themeSwitcherCheck.checked = true
    } else {
      themeSwitcherCheck.checked = false
    }
  }

  // Слушаем изменения системной темы (игнорируем старые браузеры)
  try {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', () => {
        const storedTheme = getStoredTheme()
        if (storedTheme !== 'light' && storedTheme !== 'dark') {
          setTheme(getPreferredTheme())
        }
      })
  } catch (e) {
    // Игнорируем ошибку в старых браузерах
  }

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme())

    document.querySelectorAll('[data-bs-toggle="mode"]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const theme =
          toggle.querySelector('input[type="checkbox"]').checked === true
            ? 'dark'
            : 'light'
        setStoredTheme(theme)
        setTheme(theme)
        showActiveTheme(theme, true)
      })
    })
  })
})()
